import { GetState } from 'zustand';
import getLedspClient from '../../../../utils/get-ledsp-client';
import { ICountdown } from '../../concepts/countdown';
import { IDocs } from '../../concepts/docs';
import { IGame } from '../../concepts/game';
import { IKpi } from '../../concepts/kpi';
import { ILocations } from '../../concepts/locations';
import { IPlayer } from '../../concepts/player';
import { IToDos, VotingPayload } from '../../concepts/to-dos';
import { IVoting } from '../../concepts/voting';
import { IPhaseExecutorFn } from '../game';

export const startPhase2Voting: IPhaseExecutorFn = (
  get: GetState<
    IGame & IDocs & IToDos & ILocations & IVoting & IPlayer & ICountdown & IKpi
  >
) => {
  get().closeLocation('/');
  get().closeMeeting();
  get().pinLocation('phases/phase-2/vote');
  get().openLocation('phases/phase-2/vote');

  get().clearToDos();
  ToDos.forEach(get().appendToDo);

  get().startVotingSession('phase-2', {
    availableVotes: get().availableAllocationVotes(),
    voters: get().players,
    isMotivationRequired: false,
  });

  get().appendToDo<VotingPayload>({
    id: 'vote-phase-2',
    type: 'vote',
    locationToVisit: 'phases/phase-2/vote',
    nudge: '',
    payload: {
      sessions: ['phase-2'],
      gotoPhase: 'phase-2-outcomes',
    },
  });

  get().startCountdown(get().currentPhaseStartTime, 5 * 60 * 1000);

  getLedspClient().sendGameProgressEvent({
    step: 'Phase2',
    stage: 'Voting',
    gameId: get().gameId,
    playerId: get().playerId,
    teamId: get().team,
    eventType: 'game-stage-entered',
  });
};

const ToDos = [];
